/**
 * External Tasks filter - Task Name (first) + Retention fields.
 * Task Name uses CustomTextSearch (Default Target Margin style).
 * Same CustomFilter pattern as DashboardRetentionFilter.
 */
import { CustomFilter } from 'app/ComponentLibrary/Filter';
import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  defaultExternalTasksFilterValues,
  getDashboardExternalTasksFilterSpecs,
} from './DashboardRetentionFilterUtils';

export const defaultValues = defaultExternalTasksFilterValues;

export interface DashboardExternalTasksFilterProps {
  onApplyFilter: (values: Record<string, unknown>) => void;
  onAfterReset?: () => void;
}

export const DashboardExternalTasksFilter: React.FC<DashboardExternalTasksFilterProps> = ({
  onApplyFilter,
  onAfterReset,
}) => {
  const { setValue } = useFormContext();
  const fields = useMemo(() => getDashboardExternalTasksFilterSpecs(), []);

  const resetFilter = () => {
    Object.entries(defaultExternalTasksFilterValues).forEach(([key, val]) => setValue(key, val));
    onApplyFilter(defaultExternalTasksFilterValues);
    onAfterReset?.();
  };

  return (
    <CustomFilter
      fields={fields}
      onResetForm={resetFilter}
      justifyContent="flex-start"
      version2
      analytics={{ caller: 'TaskOperations', onApply: true, properties: { category: 'Dashboard' } }}
    />
  );
};
